module.exports = __webpack_public_path__ + "static/img/gaozhongdili.d7aa299a.jpg";